"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HYPER_DOC_TYPE = void 0;
exports.HYPER_DOC_TYPE = {
    Account: 'account',
    State: 'state',
    Region: 'region',
    Language: 'language',
    Integration: 'integration',
    Locale: 'locale',
    AccountIntegration: 'account-integration',
    AccountCopies: 'account-copies',
    AccountIntent: 'account-intent',
    AccountSlot: 'account-slot',
    AccountSlotTypeValue: 'account-slot-type-value',
    AccountIntentSlot: 'account-intent-slot',
    AccountIntentUtterance: 'account-intent-utterance',
    Deliveries: 'deliveries',
    Copies: 'copies',
    Intent: 'intent',
    Product: 'product',
    Feature: 'feature',
    Lexbot: 'lexbot',
    SNS_TOPIC_ARN: 'PULUMI_SNS_TOPIC_ARN',
    SQS_QUEUE_URL: 'PULUMI_SQS_QUEUE_URL'
};
